import { formatMoneyWithCurrency } from "src/utils/formatter";
import { groupAccountsByCompanyId, processBankAccounts } from "./utils/functions";
import { InfoCard } from "./utils/InfoCard"
import { ResumeMonthToPay } from "./utils/PorCobrarComponents/ResumeMonthToPay";
import { ResumeBalances } from "./utils/SaldosComponents/ResumeBalances";
import { useMemo, useState } from "react";
import FeatherIcon from "feather-icons-react";

const currencyNames = {
  CLP: 'Pesos Chilenos (CLP)',
  USD: 'Dólar (USD)',
  EUR: 'Euro (EUR)'
};

export const Saldos = ({ source }) => {

  const [selectedCurrency, setSelectedCurrency] = useState('CLP');

  const {
    groupedAccounts = {},
    groupedByCompanyId ={},
    currencies={},
    cardsData={}

  } = useMemo(()=>{

    if(!source) return {}
    const groupedAccounts = processBankAccounts(source.allBankBalancesHolding);
  
    const groupedByCompanyId = groupAccountsByCompanyId(source.allBankBalancesHolding)

    const currencies = groupedAccounts.map(item => item.currencyType);
  
    const cardsData = groupedAccounts.flatMap(accountGroup => [
      {
        id: `total-balance-${accountGroup.currencyType}`,
        name: 'Saldo total',
        subName: accountGroup.currencyType,
        amount: formatMoneyWithCurrency(accountGroup.totalAvailableBalance, accountGroup.currencyType),
        classBG: 'tw-bg-gray-100 tw-border-solid tw-border-[1px] tw-border-gray-200',
        classTitle: 'tw-text-gray-600',
        classAmount: 'tw-text-black',
        classSubAmount: 'tw-text-black',
        classDiv: 'tw-ms-auto'
      },
      {
        id: `credit-line-${accountGroup.currencyType}`,
        name: 'Línea de crédito',
        subName: accountGroup.currencyType,
        amount: formatMoneyWithCurrency(accountGroup.totalCreditLineAvailable, accountGroup.currencyType),
        classBG: 'tw-bg-gray-100 tw-border-solid tw-border-[1px] tw-border-gray-200',
        classTitle: 'tw-text-gray-600',
        classAmount: 'tw-text-black',
        classSubAmount: 'tw-text-black',
        classDiv: 'tw-ms-auto'
      },
      {
        id: `account-count-${accountGroup.currencyType}`,
        name: 'Total de cuentas',
        subName: accountGroup.currencyType,
        amount: accountGroup.accountCount,
        classBG: 'tw-bg-gray-100 tw-border-solid tw-border-[1px] tw-border-gray-200',
        classTitle: 'tw-text-gray-600',
        classAmount: 'tw-text-black tw-capitalize',
        classDiv: 'tw-ms-auto'
      }
    ]);
    return {

      groupedAccounts,
      groupedByCompanyId,
      currencies,
      cardsData
    }
  }, [source])


  return (
    <>
      {
        source ? (
          <>

            <div className="tw-flex tw-flex-col tw-gap-10 tw-w-full tw-bg-white tw-rounded-md tw-p-7">
              <div>
                <p className="tw-font-medium tw-text-xl tw-text-black">Estados financieros por tipo de moneda</p>
              </div>
              <div className="tw-flex tw-flex-wrap tw-gap-6">
                {cardsData.map((item, index) => (
                  <div key={item.id} className="tw-flex-[0_0_calc(33.333%_-_1.5rem)]">
                    <InfoCard
                      name={item.name}
                      subName={item.subName}
                      amount={item.amount}
                      subAmount={item.subAmount}
                      classBG={item.classBG}
                      classTitle={item.classTitle}
                      classAmount={item.classAmount}
                      classSubAmount={item.classSubAmount}
                      classDiv={item.classDiv}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="tw-bg-white tw-rounded-md tw-p-7 tw-flex tw-flex-col tw-gap-10 tw-mt-6">
              <div className="tw-flex tw-justify-between">
                <div>
                  <p className="tw-font-medium tw-text-xl tw-text-black">Resumen de cuentas bancarias por empresa</p>
                </div>
                <div className="tw-items-center tw-gap-2 tw-relative tw-inline-block">
                  <select
                    id="currency-select"
                    value={selectedCurrency}
                    onChange={(e) => setSelectedCurrency(e.target.value)}
                    className="!tw-border-solid !tw-border-[1px] !tw-border-gray-300 !tw-rounded-md !tw-px-3 !tw-py-1 !tw-w-[200px] !tw-text-black !tw-text-[14px]"
                    style={{
                      all: 'unset'
                    }}
                  >
                    {currencies.map(currency => (
                      <option key={currency} value={currency}>{currencyNames[currency] || currency}</option>
                    ))}
                  </select>
                  <FeatherIcon icon="chevron-down" size={20} className="tw-pointer-events-none tw-absolute tw-right-2 tw-top-1/2 -tw-translate-y-1/2" />
                </div>
              </div>
              <div className="tw-flex tw-flex-col tw-gap-6">
                {groupedByCompanyId
                  .map(account => ({
                    ...account,
                    items: account.items.filter(item => {
                      const currencyData = groupedAccounts.find(d =>
                        d.accounts.some(acc =>
                          acc.bankId === item.bankId &&
                          acc.availableBalance === item.availableBalance
                        )
                      );
                      return currencyData?.currencyType === selectedCurrency;
                    })
                  }))
                  .filter(account => account.items.length > 0)
                  .map((account, index) => (
                    <ResumeBalances
                      key={`${account.companyId}-${selectedCurrency}`}
                      source={account.items}
                      companyId={account.companyId}
                      isToPay={false}
                    />
                  ))}
              </div>
            </div>
          </>
        )
          : (
            <div class="tw-bg-white tw-rounded-md tw-p-6">
              <div className="tw-flex tw-gap-6 tw-h-[13vh]">
                <div className="tw-w-1/4 tw-bg-gray-300 tw-animate-pulse tw-rounded-md"></div>
                <div className="tw-w-1/4 tw-bg-gray-300 tw-animate-pulse tw-rounded-md"></div>
                <div className="tw-w-1/4 tw-bg-gray-300 tw-animate-pulse tw-rounded-md"></div>
                <div className="tw-w-1/4 tw-bg-gray-300 tw-animate-pulse tw-rounded-md"></div>
              </div>
              <div class="tw-flex tw-items-end tw-gap-6 tw-w-full tw-h-[43vh]">
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[20vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[25vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[35vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[32vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[23vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[30vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[21vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[18vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[24vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[27vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[10vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[29vh]"></div>
                <div class="tw-w-1/12 tw-bg-gray-300 tw-animate-pulse tw-rounded-t tw-h-[16vh]"></div>
              </div>
            </div>
          )
      }
    </>
  )
}